<div
	ucImpression
	(onImpression)="onUniImpression($event)"
	class="flex items-center justify-between w-full gap-3 py-5 lg:py-0 lg:flex-col lg:items-start"
>
	<div class="flex items-center w-full gap-3 lg:gap-4 lg:flex-col lg:items-start">
		<div class="block w-16 lg:w-full">
			<!-- mobile: logo -->
			<a class="relative block w-16 h-16 lg:hidden" [routerLink]="[redirectUrl()]">
				<img
					[ngSrc]="uni().logo | cdn"
					fill
					[attr.alt]="'Logo of ' + uni().name"
					class="absolute object-contain border rounded-2xl"
					data-cy="recommended-uni-logo"
					ucUniProfileGAEvent
					[eventTypes]="['click']"
					[uniId]="uni().id"
					[uniName]="uni().name"
					[ugSearchOrderPosition]="ugso()"
					[cleSearchOrderPosition]="cleso()"
					[product]="product()"
				/>
			</a>

			<!-- desktop: cover photo-->
			<div class="relative hidden lg:w-full lg:block lg:h-44">
				<div class="absolute z-10 top-4 right-4">
					<uc-bookmark
						[bookmarkHeartIcon]="true"
						[saved]="uni().saved"
						[id]="uni().id"
						[delta]="1"
						[componentName]="componentName()"
						[product]="product()"
						[uniName]="uni().name"
						[ugSearchOrderPosition]="
							product() === 'undergraduate' ? uni().order : null
						"
						[cleSearchOrderPosition]="uni().order"
					/>
				</div>
				@if (uni().profile?.cover_image) {
					<a
						ucUniProfileGAEvent
						[eventTypes]="['click']"
						[uniId]="uni().id"
						[uniName]="uni().name"
						[ugSearchOrderPosition]="ugso()"
						[cleSearchOrderPosition]="cleso()"
						[product]="product()"
						[routerLink]="[redirectUrl()]"
					>
						<img
							[ngSrc]="uni().profile?.cover_image | cdn"
							fill
							[attr.alt]="'Photo of ' + uni().name"
							class="object-cover rounded-2xl"
							data-cy="recommended-uni-cover-image"
						/>
					</a>
				}
			</div>
		</div>
		<div>
			<h3 class="text-lg font-bold text-gray-900">
				<a
					[routerLink]="[redirectUrl()]"
					ucUniProfileGAEvent
					[eventTypes]="['click']"
					[uniId]="uni().id"
					[uniName]="uni().name"
					[ugSearchOrderPosition]="ugso()"
					[cleSearchOrderPosition]="cleso()"
					[product]="product()"
					data-cy="recommended-uni-name"
				>
					{{ uni().name | uni }}
				</a>
			</h3>
			@if (uni().stats.recommended_percentage) {
				<p class="mt-1 text-sm text-gray-500">
					{{ uni().stats.recommended_percentage }}% Recommended
				</p>
			}
			@if (!uni().stats.recommended_percentage) {
				<uc-write-review-btn
					[universityId]="uni().id"
					[universityName]="uni().name"
					[universityUrl]="uni().slug"
					buttonText="Leave a review"
				/>
			}
		</div>
	</div>

	<!-- desktop btns -->
	<div class="hidden w-full gap-3 lg:flex lg:flex-col xl:gap-4 xl:flex-row">
		@if (!isClearing()) {
			<uc-request-btn
				class="w-full"
				[params]="uni().id"
				[componentName]="componentName()"
				customStyles="!w-full lg:px-3.5"
				[product]="product()"
				[ugSearchOrderPosition]="uni().order"
			/>
		}
		@if (uni().profile?.external_url) {
			<uc-recommended-visit-website-btn
				class="w-full"
				customStyles="block secondary-button w-full lg:px-3.5"
				[product]="product()"
				[componentName]="componentName()"
				[uniId]="uni().id"
				[uniName]="uni().name"
				[externalUrl]="uni().profile?.external_url!"
				[searchOrderPosition]="uni().order"
				[privacyPolicyUrl]="uni().privacy_policy_url"
				data-cy="recommended-uni-visit-website-btn-desktop"
			/>
		}
	</div>

	<!-- mobile btns -->
	<div class="lg:hidden">
		@if (uni().profile?.external_url) {
			<uc-recommended-visit-website-btn
				[product]="product()"
				[componentName]="componentName()"
				[searchOrderPosition]="uni().order"
				[uniId]="uni().id"
				[uniName]="uni().name"
				[externalUrl]="uni().profile?.external_url!"
				buttonText="Website"
				[privacyPolicyUrl]="uni().privacy_policy_url"
				data-cy="recommended-uni-visit-website-btn-mobile"
			/>
		}
	</div>
</div>
